// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Checkbox,
    OutlinedInput,
    Rating,
    Autocomplete
} from '@mui/material'


import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import { useNavigate, useParams } from "react-router-dom";

import Icon from '../../../../../../components/icon';
import MsiDatagridDynamic from '../../../../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../../../../configs/constant';
import React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface CustomProps extends NumericFormatProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name?: string;
}

const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(function NumericFormatCustom(
    props,
    ref
) {
    const { onChange, ...other } = props

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={values => {
                onChange({
                    target: {
                        name: props.name ?? '',
                        value: values.value
                    }
                })
            }}
            thousandSeparator
            valueIsNumericString
        />
    )
})

export default function Detail() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    const { id } = useParams();
    const navigate = useNavigate();

    // State
    const [valGudang, setValGudang] = useState<any>(null)
    const [listGudang, setListGudang] = useState<any[]>([])
    const [valSubGudang, setValSubGudang] = useState<any>(null)
    const [listSubGudang, setListSubGudang] = useState<any[]>([])

    useEffect(() => {
        getData()
    }, [])

    const getData = () => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/mm/gudang-kain/add-gr-detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const master = response.data.master[0]
                    const detail = response.data.detail[0]

                    setValueDetail(master, detail)

                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getGudang = (ids: any) => {
        const url = apiUrl.apiUrl + '/mm/gudang/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    data.forEach((element: any) => {
                        if (element.id === ids) {
                            setValGudang(element)
                            setValue('mmgudang_id', element.id)
                        }
                    });
                    setListGudang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getSubGudang = (gudangId: any) => {
        const url = apiUrl.apiUrl + '/mm/sub-gudang/list-combo'
        axios
            .get(url, {
                params: { mmgudang_id: gudangId },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListSubGudang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const setValueDetail = (master: any, detail: any) => {
        setValue('mmgudang_id', 12510000003)
        getGudang(12510000003)
        getSubGudang(12510000003)

        setValue('accbudget_detail_d_id', detail.accbudget_detail_d_id)
        setValue('kode', detail.kode)
        setValue('konversi', detail.konversi)
        setValue('mmbarang_id', detail.mmbarang_id)
        setValue('mmsatuan_doc_id', detail.mmsatuan_doc_id)
        setValue('mmsatuan_id', detail.mmsatuan_id)
        setValue('nama', detail.nama)
        setValue('nama_vendor', master.nama_vendor)
        setValue('pbpo_d_id', detail.id)
        setValue('pbpo_id', detail.pbpo_id)
        setValue('pbpr_d_id', detail.pbpr_d_id)
        setValue('pbsupplier_id', master.pbsupplier_id)
        setValue('ppn', master.ppn_persen)
        setValue('qty', detail.qty_doc)
        setValue('harga', detail.harga)
        setValue('total', detail.total)
        setValue('sysdoctag_id', 12510000009)
    }

    const handleChangeAutocomplete = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_sub_id', newValue?.id)
        setValSubGudang(newValue)
    }

    const handleChangeAutocompleteGudang = (event: SyntheticEvent, newValue: any | null) => {
        setValue('mmgudang_id', newValue ? newValue.id : null)
        setValGudang(newValue.nama)
    }

    interface FormInputs {
        pmrequest_id: any
        sysdoctag_id: any
        pbsupplier_id: any
        pbpo_id: any
        mmgudang_id: any
        mmgudang_sub_id: any
        accakun_id: any
        tgl_kirim: any
        transportasi: any
        nomor_timbang: any
        nomor_plat: any
        nomor_sj: any
        kurir: any
        berat_timbang: any
        keterangan: any
        nama_vendor: any
        ppn: any

        pbgr_id: any
        pbpr_d_id: any
        pbpo_d_id: any
        mmbarang_id: any
        mmsatuan_id: any
        mmsatuan_doc_id: any
        accbudget_detail_d_id: any
        kode: any
        nama: any
        konversi: any

        qty: any
        harga: any
        total: any
    }

    const defaultValues = {
        accbudget_detail_d_id: '',
        berat_timbang: '',
        keterangan: '',
        kurir: '',
        nomor_timbang: '',
        transportasi: '',
        sysdoctag_id: 12510000009, // default GR-Kain
        mmgudang_id: null,
        mmgudang_sub_id: null,
        tgl_kirim: '',
        nomor_sj: '',
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })


                const url = apiUrl.apiUrl + '/mm/gudang-kain/save-master-gr'

                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    const id = response.data.id
                                    navigate(`/mm/gudang/kain/detail/${id}?tab=9&tab_gr=0`)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => navigate('/mm/gudang/kain?tab=9&tab_gr=3')}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Goods Receipt
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center' }}>
                        No. PO : <b>{id}</b>
                    </Typography>
                    <br />
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3} sx={{ mt: 1 }}>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <InputLabel>Dokumen Penerimaan</InputLabel>
                                    <Controller
                                        name='sysdoctag_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Dokumen Penerimaan'
                                                value={value || ''}
                                                readOnly
                                                onChange={e => {
                                                    const val = e.target.value
                                                    // getUserOto(val)
                                                    onChange(e)
                                                }}
                                                error={Boolean(errors.sysdoctag_id)}
                                            >
                                                <MenuItem value={12510000009}>GR - Kain</MenuItem>
                                            </Select>
                                        )}
                                    />
                                    {errors.sysdoctag_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="mmgudang_id"
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={listGudang.find((item) => item.id === value) ?? null} // pastikan object atau null
                                                options={listGudang}
                                                getOptionLabel={(option) => option.nama || ''}
                                                isOptionEqualToValue={(option, value) => option.id === value?.id}
                                                onChange={(event, newValue) => {
                                                    onChange(newValue?.id ?? null); // set value di RHF
                                                    setValGudang(newValue); // set state untuk Autocomplete
                                                }}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Gudang"
                                                        required
                                                        InputLabelProps={{ shrink: true }}
                                                        error={Boolean(errors.mmgudang_id)}
                                                        helperText={errors.mmgudang_id && 'Form ini tidak boleh kosong.'}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <InputLabel>Sub Gudang</InputLabel>
                                    <Controller
                                        name='mmgudang_sub_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valSubGudang}
                                                options={listSubGudang}
                                                id='mmgudang_sub_id'
                                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                                onChange={handleChangeAutocomplete}
                                                renderOption={(props, option) => {
                                                    return (
                                                        <li key={option.id} {...props}>
                                                            {option.kode} | {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={option => option.nama}
                                                renderInput={params => (
                                                    <TextField {...params} InputLabelProps={{ shrink: true }} label='Subgudang' />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.mmgudang_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_kirim'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                type='date'
                                                value={value}
                                                label='Tanggal Kirim'
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.tgl_kirim)}
                                            />
                                        )}
                                    />
                                    {errors.tgl_kirim && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Tanggal harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nomor_timbang'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label='No. Timbang'
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.nomor_timbang)}
                                            />
                                        )}
                                    />
                                    {errors.nomor_timbang && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='transportasi'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label='Transportasi'
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.transportasi)}
                                            />
                                        )}
                                    />
                                    {errors.transportasi && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nomor_sj'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label='Surat Jalan'
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.nomor_sj)}
                                            />
                                        )}
                                    />
                                    {errors.nomor_sj && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name="berat_timbang"
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label="Berat Timbang"
                                                value={value ?? ''} // pastikan tidak null
                                                onChange={onChange}
                                                InputProps={{
                                                    inputComponent: NumericFormatCustom as any
                                                }}
                                            />
                                        )}
                                    />
                                    {errors.berat_timbang && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kurir'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                label='Kurir'
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.kurir)}
                                            />
                                        )}
                                    />
                                    {errors.kurir && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                fullWidth
                                                multiline
                                                rows={2}
                                                label='Keterangan'
                                                value={value}
                                                onChange={onChange}
                                                InputLabelProps={{ shrink: true }}
                                                error={Boolean(errors.keterangan)}
                                            />
                                        )}
                                    />
                                    {errors.keterangan && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>

        </Grid>
    )
}
